export default __webpack_public_path__ + "static/media/App_Store_Badge.49a314ac.svg";